import React from 'react';
import operaHelp1 from './OperaAppHelpImages/opera_chrome_extension.png';
import operaHelp2 from './OperaAppHelpImages/opera_chrome_install.png';
import operaHelp4 from './OperaAppHelpImages/opera_confirm_install.png';
import operaHelp5 from './OperaAppHelpImages/opera_complete.png';
import A from '../../atoms/A/A';
import Image from 'components/atoms/Image/Image';

export interface Props {}

const OperaAppHelp: React.FC<Props> = () => {
  return (
    <>
      <h1>Install Help - Opera</h1>
      <ol>
        <li>
          <p>
            To use the browser app on Opera, you first need to ensure that you have{' '}
            <A to="https://addons.opera.com/en-gb/extensions/details/install-chrome-extensions/">
              chrome extensions installed.
            </A>
          </p>
          <p>
            Then click the <strong>Get the Browser App</strong> button. Opera will take you to the
            Chrome installation page.
          </p>
          <Image quality={100} src={operaHelp1} alt="opera-chrome-extension-instruction" />
        </li>
        <li>
          <p>
            Next click the <strong>Add to Opera button.</strong>
          </p>
          <Image quality={100} src={operaHelp2} alt="opera-add-button-instruction" />
        </li>
        <li>
          <p>
            Next click <strong>Add extension</strong>
          </p>
          <Image quality={100} src={operaHelp4} alt="opera-final-install-instruction" />
        </li>
        <li>
          <p>
            You&apos;re good to go! Follow the link to make your first earnings through the
            extension.
          </p>
          <Image quality={100} src={operaHelp5} alt="opera-try-app-instruction" />
        </li>
      </ol>
    </>
  );
};

export default OperaAppHelp;
